import { useState, useEffect } from "react";
import { FiPlus, FiX } from "react-icons/fi";

const faqs = [
  {
    id: 1,
    question: "Does LeadBook provide support during the deal?",
    answer:
      "Yes, our team provides complete support throughout your deal process.",
  },
  {
    id: 2,
    question: "Can builders and agents also list properties?",
    answer:
      "Absolutely! Both builders and agents can easily list their properties with us.",
  },
  {
    id: 3,
    question: "How do I find the right property quickly?",
    answer:
      "Use our filters and AI recommendations to discover your ideal property faster.",
  },
  {
    id: 4,
    question: "What cities does LeadBook cover?",
    answer:
      "We are expanding rapidly and currently cover major cities and growing towns across India.",
  },
  {
    id: 5,
    question: "Can I contact sellers or builders directly?",
    answer:
      "Yes, you can contact sellers or builders directly through our platform.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init({
        duration: 800, // Animation duration in milliseconds
        once: true, // Animation happens only once on scroll
      });
    }
  }, []);

  return (
    <section className="bg-[#F7F9FC] py-10">
      <div className="mx-auto">
        <h2
          className="text-[#031722] font-[Poppins] font-medium text-[32px] leading-[150%] tracking-[1%] mb-10 text-center sm:text-left"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Frequently Asked Questions
        </h2>

        <div className="grid md:grid-cols-2 gap-5">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              onClick={() => toggleFAQ(index)}
              className={`cursor-pointer border rounded-2xl p-5 flex flex-col justify-between
                ${
                  openIndex === index
                    ? "bg-[#FFF6ED] border-[#FFA559] shadow-md"
                    : "bg-white border-transparent"
                }`}
              data-aos="fade-up"
              data-aos-delay={200 + index * 100}
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full text-[#FF8B13] font-semibold text-[16px]
                    ${openIndex === index ? "bg-[#FFE8D1]" : "bg-[#F3F3F3]"}`}
                >
                  {faq.id.toString().padStart(2, "0")}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <h3 className="text-[#222] font-[Poppins] font-semibold text-[18px] leading-[150%]">
                      {faq.question}
                    </h3>
                    <span className="text-[#FF8B13] text-lg">
                      {openIndex === index ? <FiX /> : <FiPlus />}
                    </span>
                  </div>
                  {openIndex === index && (
                    <p
                      className="mt-2 text-[#676767] font-[Poppins] text-[16px] leading-[150%] tracking-[1%]"
                      data-aos="fade-in"
                      data-aos-delay="300"
                    >
                      {faq.answer}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
